import AppliedJobCard from '../../components/AppliedJobCard';
import { useSelector } from '../../../../../store/store';
import Spinner from '../../../../../components/Spinner';
import NoData from '../../../../../components/NoData';
import styles from './style.module.scss';
import {
    selectExamsHistory,
    selectFetchingExamsHistory,
} from '../../../../../store/workspace/selectors';

/** Every job the applicant has applied to, newest state first. */
function JobApplications() {
    const history = useSelector(selectExamsHistory);
    const fetching = useSelector(selectFetchingExamsHistory);

    return (
        <div className={styles.wrapper}>
            <span className={styles.title}>
                Job applications
            </span>

            <div className={styles.list}>
                {fetching && <Spinner />}
                {history.map(exam => <AppliedJobCard key={`${exam.id}-${exam.status}`} info={exam} />)}
            </div>

            {!fetching && history.length === 0 && <NoData />}
        </div>
    )
};

export default JobApplications;
